(function () {
    'use strict';

    angular
        .module('app')
        .factory('RoleService', RoleService);


    function RoleService($http, $q, $rootScope, WebAPIUrl) {

        var service = {
            getAllRoles: getAllRoles,
            getRoleByID: getRoleByID,
            getRolePermissions: getRolePermissions,
            getRolePermissionsAssignment: getRolePermissionsAssignment,
            createRole: createRole,
            saveRole: saveRole,
            checkRoleName: checkRoleName
        };

        return service;

        function getAllRoles() {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Role/Roles',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getRoleByID(roleId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Role/GetRole?RoleId=' + roleId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        };

        function getRolePermissions(roleId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Role/GetRolePermissions?RoleId=' + roleId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        };

        function getRolePermissionsAssignment(roleId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Role/GetRolePermissionsAssignment?RoleId=' + roleId,
            }).success(function (data, status, headers, cfg) {
                //console.log(data);
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        };

        function createRole(roleData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Role/CreateRole",
                data: roleData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        };

        function saveRole(roleData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Role/UpdateRole",
                data: roleData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        };

        function checkRoleName(roleName, roleId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + "/api/Role/CheckRoleName?RoleName=" + roleName + "&RoleId=" + roleId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        };

    }

})();